import React, { useCallback, useEffect, useState } from "react";
import getServerSideProps from "~/app/getServerSideProps";
import { findSelectedProductValues, getProductsData } from "~/cores/appCore";
import ProductModal from "../return/methodSelector/ProductModal";
import { IFRAME_ACTIONS } from "rylak-common/src/constants";

const IframeModal = function (props) {
    const { appProps } = props;
    const [receivedData, setReceivedData] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const listenerFunction = useCallback(
        (e) => {
            if (e.data?.action === IFRAME_ACTIONS.TO_MODAL_IFRAME_OPEN_IFRAME_PRODUCT_MODAL) {
                const data = e.data?.data;
                setReceivedData(data);
                setShowModal(true);
            }

            if (e.data?.action === IFRAME_ACTIONS.TO_MODAL_IFRAME_LANGUAGE_CHANGED) {
                appProps?.setLanguage(e.data?.data?.language);
            }
        },
        [appProps?.setLanguage, setShowModal, setReceivedData],
    );

    useEffect(() => {
        window.parent.postMessage(
            {
                action: showModal ? IFRAME_ACTIONS.OPEN_MODAL : IFRAME_ACTIONS.CLOSE_MODAL,
            },
            "*",
        );
    }, [showModal]);

    useEffect(() => {
        window.addEventListener("message", listenerFunction);

        return () => {
            window.removeEventListener("message", listenerFunction);
        };
    }, [listenerFunction]);

    const onSaveChoice = useCallback((data, refundOptionType) => {
        //TODO same action name that just get passed between iframes
        window.parent.postMessage(
            {
                action: IFRAME_ACTIONS.TO_MAIN_IFRAME_SAVE_PRODUCT_CHOICE,
                relayToOtherIframe: true,
                data: data,
                refundOptionType: refundOptionType,
            },
            "*",
        );
    }, []);

    const { appPropsAsString, productId } = receivedData || {};

    const receivedAppPropsAsObject = JSON.parse(appPropsAsString || "{}");

    const actualAppProps = {
        ...receivedAppPropsAsObject,
        getLocaleText: appProps.getLocaleText,
        system: appProps.system,
        navigate: appProps.navigate,
        router: appProps.router,
        addAlert: appProps.addAlert,
    };

    const products = getProductsData(actualAppProps);

    const product = products?.find((p) => p.sessionItemId === productId);

    return (
        <div style={{ pointerEvents: "auto" }}>
            {receivedData && showModal && (
                <ProductModal
                    appProps={actualAppProps}
                    showModal={showModal}
                    product={product}
                    onModalClose={() => setShowModal(false)}
                    productExchangeServiceData={actualAppProps?.productsExchangeServiceData[productId]}
                    similarProductServiceData={actualAppProps?.similarProductsServiceData[productId]}
                    selectedProductValues={findSelectedProductValues(actualAppProps, productId)}
                    onSave={(data, refundOptionType) => {
                        // TODO postMessageBack
                        onSaveChoice(data, refundOptionType);
                        setShowModal(false);
                    }}
                />
            )}
        </div>
    );
};

export { getServerSideProps };
export default IframeModal;
